

import request from "@/utils/request";

const baseService = "autoapp-default-server-recovery";

//订单异步导出
export function exportOrderAsync(data) {
  return request({
    url: `${baseService}/api/tblRecycleOrder/exportOrderAsync`,
    method: "post",
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/order.js